import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { tap } from "rxjs/internal/operators/tap";

import { ExecutionResultModel } from "../../models/api/execution-result.model";
import { LoggerService } from "../logging/logger.service";

@Injectable({
    providedIn: "root"
})
export class ApiRequestDispatcherService {
    public constructor(
        private _http: HttpClient,
        private _logger: LoggerService
    ) {
    }

    public get<TResult>(url: string, params?: any): Observable<ExecutionResultModel<TResult>> {
        const response$ = this._http.get<ExecutionResultModel<TResult>>(url, { params: params });
        return this.appendLoggerToFlow(response$, url, params);
    }

    public post<TResult>(url: string, body: any | null): Observable<ExecutionResultModel<TResult>> {
        const response$ = this._http.post<ExecutionResultModel<TResult>>(url, body);
        return this.appendLoggerToFlow(response$, url, null, body);
    }

    private appendLoggerToFlow<TResult>(response$: Observable<ExecutionResultModel<TResult>>, url: string, params?: any, body?: any): Observable<ExecutionResultModel<TResult>> {
        const stackTrace = { stack: "" };

        if (Error.captureStackTrace) {
            Error.captureStackTrace(stackTrace, this.appendLoggerToFlow);
        } else {
            stackTrace.stack = new Error().stack;
        }

        return response$.pipe(
            tap(response => {
                this._logger.debug(`API method call: "${url}"`, {
                    request: {
                        url: url,
                        params: params,
                        body: body
                    },
                    response: response,
                    stackTrace: (stackTrace.stack || "")
                        .split("\n")
                        .filter(line => line.includes("./ts/app"))
                        .splice(1, 10)
                        .map(line => line.trim())
                });
            })
        );
    }
}
